<template>
  <div
    class="board-cell"
    :class="{
      'is-anchor': isAnchor,
      'is-path': hasPath,
      'is-blocked': isBlocked,
    }"
    :data-positionx="cell.positionx"
    :data-positiony="cell.positiony"
  >
    <shape-icon
      v-if="isAnchor"
      :shape="cell.shape"
      :color="cell.color"
      :value="cell.value"
      :filled="cell.filled"
      :size="iconSize"
      :settings="settings"
    />

    <shape-path
      v-else-if="hasPath"
      :direction="cell.direction"
      :color="activeColor"
      :pathWeight="settings.pathWeight"
    />
  </div>
</template>

<script>
import ShapeIcon from './elements/ShapeIcon.vue';
import ShapePath from './elements/ShapePath.vue';

export default {
  name: 'ShapeCell',
  components: {
    ShapeIcon,
    ShapePath,
  },
  props: {
    cell: { type: Object, required: true },
    cellSize: { type: Number, default: 60 },
    settings: { type: Object, required: true },
  },
  computed: {
    isAnchor() {
      return this.cell.shape !== null;
    },
    isBlocked() {
      return this.cell.isBlocked;
    },
    hasPath() {
      return this.settings.showAnswer && this.cell.direction !== null;
    },
    activeColor() {
      return this.settings.colored && this.cell.color
        ? this.cell.color
        : '#000000';
    },
    iconSize() {
      return Math.round(this.cellSize * 0.6);
    },
  },
};
</script>

<style scoped>
.board-cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000;
  cursor: pointer;
  box-sizing: border-box;
}

.is-blocked{
  background-color: #000;
}
</style>
